import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs'
@Injectable({
    providedIn: 'root'
})

export class LogService {
    public _val = new BehaviorSubject<any>('');
    emit<T>(data: T){
        this._val.next(data)
    }

    on<T>(): Observable<T>{
        return this._val.asObservable();
    }

    // numVal:string
    // setVal(dataVal){
    //     this.numVal = dataVal
    //     console.log(this.numVal +"service val set")
    // }
    // getVal(){
    //     return this.numVal
    //     console.log(this.numVal +"service val get")
    // }

    log(msg: any) {
        console.log(new Date() + ": " + JSON.stringify(msg));
    }
}